import { NAMESPACE as PARENT_NAMESPACE } from "../_Namespace";

export const NAMESPACE = `${PARENT_NAMESPACE}Mixins/`;